"use strict";

exports.__esModule = true;
exports.DashboardNavbar = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = require("styled-components");
var _App = require("../../App");
var _System = require("../../../System");
var _Utils = require("../../../Utils");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _DashboardCollection = require("../DashboardCollection");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Navbar for specific dashboards.
 */
var DashboardNavbar = exports.DashboardNavbar = (0, _reactRouterCompat.withRouter)(function (props) {
  var dashboardCollection = _react["default"].useContext(_DashboardCollection.DashboardCollectionContext);
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var title = props.title,
    dashboard = props.dashboard,
    history = props.history;
  return /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    "data-testid": "DashboardNavbar",
    title: title,
    leftContent: /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSelector, {
      theme: theme,
      large: true,
      minimal: true,
      style: {
        fontSize: theme.NavbarTitleFontSize,
        fontWeight: theme.NavbarTitleFontWeight,
        fontFamily: theme.uiModern ? theme.FontFamilyHeading : undefined
      },
      items: dashboardCollection.optimisticSearch() || (dashboardCollection.search(), []),
      selected: [dashboard],
      width: 400,
      onSelect: function onSelect(_ref) {
        var selectedDashboard = _ref[0];
        if (!selectedDashboard || selectedDashboard.id === dashboard.id) {
          return;
        }
        history.push((0, _System.getScreenLocation)("Dashboard", {
          id: selectedDashboard.id
        }, (0, _System.getLocationQuery)(history.location)));
      }
    })
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    icon: _icons.IconNames.FULLSCREEN,
    onClick: handleFullscreenClick
  }));
});
function handleFullscreenClick() {
  var element = document.querySelector("[data-allow-fullscreen]");
  if (element == null) {
    return;
  }
  (0, _Utils.requestFullscreen)(element);
}